import React, { useEffect, useState } from 'react';
import { App, InputNumber } from 'antd';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';

import { GenericModal } from '../../../../../shared/ui/GenericModal';
import { useUpdateCommissionMutation } from '../service/adminUsersApi';

export const CommissionModal = () => {
    const { notification } = App.useApp();

    const { id, commission } = useParams();
    const navigate = useNavigate();

    const commissionValue = commission ? Number(commission) : null;
    const [value, setValue] = useState<number | null>(commissionValue);

    const [isDisabled, setIsDisabled] = useState(true);

    const [updateCommission, { isSuccess, data: commissionData }] =
        useUpdateCommissionMutation();

    useEffect(() => {
        setValue(commissionValue);
    }, [commissionValue]);

    useEffect(() => {
        setIsDisabled(
            value === null || isNaN(value) || value < 1 || value > 100
        );
    }, [value]);

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: commissionData?.message,
                duration: 2,
            });
            navigate(-1);
        }
    }, [isSuccess, commissionData, notification, navigate]);

    const handleSubmit = () => {
        if (!id || value === null) return;
        if (value === commissionValue) {
            navigate(-1);
        } else {
            updateCommission({
                id,
                commission: value,
            });
        }
    };

    return (
        <GenericModal
            title={'Изменить процент'}
            destroyOnClose
            width={360}
            open
            okText={value === commissionValue ? 'Закрыть' : 'Изменить'}
            onCancel={() => navigate(-1)}
            onConfirm={handleSubmit}
            okButtonProps={{
                disabled: isDisabled,
                danger: false,
            }}
        >
            <StyledInput
                status={isDisabled ? 'error' : null}
                value={value}
                onChange={(v: number | null) => setValue(v)}
                controls={false}
                min={1}
                max={100}
                placeholder={'Укажите новый процент'}
            />
        </GenericModal>
    );
};

const StyledInput = styled(InputNumber)`
    margin-top: 1rem;
    width: 100%;
`;
